import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectFollowingTeams,
  selectFollowingWorkGroups
} from '@features/whereabouts/store/followingTeamsAndTags.duck';

// Sorted ids of the followed teams/workgroups. The arrays are referentially
// stable while their contents are unchanged, so they are safe effect deps.
export function useFollowedGroupIds(): { teamIds: string[]; workGroupIds: number[] } {
  const followedTeams = useSelector(selectFollowingTeams);
  const followedWorkGroups = useSelector(selectFollowingWorkGroups);

  const teamIdsKey = useMemo(
    () => followedTeams.filter(Boolean).map(t => String(t.id)).sort().join(','),
    [followedTeams]);
  const workGroupIdsKey = useMemo(
    () => followedWorkGroups.filter(Boolean).map(wg => String(wg.id)).sort().join(','),
    [followedWorkGroups]);

  const teamIds = useMemo(() => teamIdsKey ? teamIdsKey.split(',') : [], [teamIdsKey]);
  const workGroupIds = useMemo(() => workGroupIdsKey ? workGroupIdsKey.split(',').map(Number) : [], [workGroupIdsKey]);

  return { teamIds, workGroupIds };
}
